import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";

export default {
    state: {
        issueListing: []
    },
    getters: {
        getIssueListing: (state) => state.issueListing,
    },
    actions: {
        fetchIssueListing({ commit }) {
            return new Promise((resolve,reject) => {
                axios.get(`${BASE_URL}/issue/listing`).then((response) => {
                    commit("setIssueListing",response.data.data.issue_listing)
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
         fetchIssueTracking({ }, issue_id) {
            return new Promise((resolve,reject) => {
                axios.get(`${BASE_URL}/issue/tracking/${issue_id}`).then((response) => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        fetchDepartmentIssueListing({ commit }, department) {
            return new Promise((resolve,reject) => {
                axios.get(`${BASE_URL}/issue/department/listing/${department}`).then((response) => {
                    commit("setIssueListing",response.data.data.issue_listing)
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createIssue({ commit }, issuePayload) {
            return new Promise((resolve,reject) => {
                axios.post(`${BASE_URL}/issue/create`,issuePayload).then((response) => {
                    commit("setIssueListing",response.data.data)
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        updateStatus({ commit }, issuePayload) {
            return new Promise((resolve,reject) => {
                axios.put(`${BASE_URL}/issue/update/status`,issuePayload).then((response) => {
                    commit("setIssueListing",response.data.data)
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        closedIssue({ commit }, issuePayload) {
            return new Promise((resolve,reject) => {
                axios.put(`${BASE_URL}/issue/closed`,issuePayload).then((response) => {
                    commit("setIssueListing",response.data.data)
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        uploadIssue({}, uploadPayload){
            return new Promise((resolve,reject) => {
              axios.put(`${BASE_URL}/issue/upload/image`,uploadPayload).then(async (response) => {
                await axios.put(response.data.url, uploadPayload.file, { headers: {'Content-Type': uploadPayload.file.type} })
                resolve(response.data.url.split("?Content-Type=")[0])
              }).catch(error => {
                console.log(error)
                reject(error)
              })
            })
          }
    },
    mutations: {
        setIssueListing: (state, issueListing) => (state.issueListing = issueListing),
    }
}